import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Commons } from '../shared/Commons';
import { ClientBrowserSessionStorageService } from './client-browser-session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  storageUrl: string = environment.productBackendEndpoint + '/storage'
  logoByOwnerIdUrl = environment.productBackendEndpoint + '/mycompany/logo/'

  constructor(
    private http: HttpClient,
    private sessionStorageService: ClientBrowserSessionStorageService
  ) { }

  getImage(fileName: string) {
    const options = {
      headers: new HttpHeaders({
        'Accept': 'image/webp,*/*'
      }),
      responseType: 'blob' as 'json'
    }
    return this.http.get<Blob>(this.storageUrl + '/config?filename=' + fileName, options)
  }

  getCompanyLogoByOwnerId(ownerId: number) {
    const options = {
      headers: new HttpHeaders({
        'Accept': 'image/webp,*/*'
      }),
      responseType: 'blob' as 'json'
    }
    return this.http.get<Blob>(this.logoByOwnerIdUrl + ownerId, options)
  }

  getProductImage(fileName: string) {
    const options = {
      headers: new HttpHeaders({
        'Accept': 'image/webp,*/*'
      }),
      responseType: 'blob' as 'json'
    }
    return this.http.get<Blob>(this.storageUrl + '/product?filename=' + fileName, options)
  }

  attachFile(sign: string, fileToUpload: File) {
    let data = new FormData();
    data.append('attachment', fileToUpload);

    const options = {
      headers: new HttpHeaders({
        'Accept': 'image/webp,*/*',
        'sign': sign,
        Authorization: Commons.sessionCredentials(this.sessionStorageService)
      }),
    }

    return this.http.post<any>(this.storageUrl, data, options)
  }

}
